import React, {useEffect, useState} from 'react';
import {Col, Icon, Layout, Row} from 'antd';
import {Link} from "react-router-dom";
import {Env} from "../../../Helpers/Env";
import useVerifyServices from "../../../Hooks/VerifyServices";
import {Images} from "../../../Helpers/Images";
import ModalFormContactUs from "../../PageComponents/Public/HomePage/ModalFormContactUs";

const Footer = props => {
    const {hasSineService, hasCraftyService, hasClubService} = useVerifyServices();
    const [visible, setVisible] = useState(false)

    const showModal = () => {
        setVisible(true)
    }

    const handleClose = () => {
        setVisible(false)
    }

    return (
        <Layout.Footer style={{ textAlign: 'center', position: 'relative', padding: 0, width: '100%', backgroundColor: 'transparent' }} className='footerMain'>
            <img className={'bannerApps'} src={Images.footer_bg}/>
            <Row className={'primary-sub-color-bg'} style={{display: 'flex', justifyContent: 'center', paddingBottom: 32}}>
                <Col sm={24} md={24} lg={20} xl={18} xxl={16}>
                    <Row gutter={[0, 32]} className={'rowFooter'}>
                        <Col xs={24} md={6}  style={{display: 'flex',alignSelf: 'center', justifyContent: 'center'}}>
                            <div style={{width: 'fit-content', display: 'flex', flexFlow: 'column'}}>
                                <span style={{fontSize: '16px', marginBottom: '10px', fontWeight: 'bold'}}>  Sobre </span>
                                <span style={{marginBottom: 8}}> <Icon type='right'/><Link to={'/termos'}> Termos de Uso </Link> </span>
                                <span> <Icon type='right'/> <Link to={'/termos'}> Políticas de Privacidade </Link> </span>
                            </div>
                        </Col>
                        <Col xs={24} md={6} style={{display: 'flex',alignSelf: 'center',  justifyContent: 'center'}}>
                            <div style={{width: 'fit-content', display: 'flex', flexFlow: 'column'}}>
                                <span style={{fontSize: '16px', marginBottom: '10px', fontWeight: 'bold'}}> Serviços </span>
                                {hasCraftyService() && <span style={{marginBottom: 8}}> <Icon type='right'/> <Link to={'/quero-contratar'}> Quero contratar </Link> </span>}
                                {/*{hasSineService() && <span style={{marginBottom: 8}}> <Icon type='right'/> <Link to={'/trabalhar'}> Quero trabalhar </Link> </span>}
                                {hasSineService() && <span  style={{marginBottom: 8}}> <Icon type='right'/> <Link to={'/curriculos'}> Quero currículos </Link> </span>}
                                {hasClubService() && <span> <Icon type='right'/> <Link to={'/estabelecimentos'}> Quero ver estabelecimentos </Link> </span>}*/}
                            </div>
                        </Col>


                        <Col xs={24} md={6} style={{display: 'flex',alignSelf: 'center',  justifyContent: 'center'}}>
                            <div style={{width: 'fit-content', display: 'flex', flexFlow: 'column'}}>
                                <span style={{fontSize: '16px', marginBottom: '10px', fontWeight: 'bold'}}> Ajuda </span>
                                 {/* {hasCraftyService() && <span style={{marginBottom: 8}}> <Icon type='right'/>  <Link to={'/ajuda'}> Perguntas frequentes - Contratante </Link> </span>}
                                {hasCraftyService() && <span style={{marginBottom: 8}}> <Icon type='right'/>  <Link to={'/ajuda'}> Perguntas frequentes - Prestador </Link> </span>}
                                {hasCraftyService() && <span style={{marginBottom: 8}}> <Icon type='right'/> <Link to={'/quero-contratar'}> Como contratar </Link> </span>}
                                {hasCraftyService() && <span  style={{marginBottom: 8}}> <Icon type='right'/> <Link to={'/trabalhar'}> Quero trabalhar </Link> </span>}*/}
                                {/*{hasSineService() && <span  style={{marginBottom: 8}}> <Icon type='right'/> <Link to={'/curriculos'}> Como ver currículos </Link> </span>}*/}
                                <span>
                                   <div style={{marginBottom:10, marginLeft:-3}}>
                                        <img src={Images.gmailIcon} alt="gmail" style={{width: 24, height:24}}/> contact@crafty.work
                                   </div>
                                    {/*
                                    <div style={{marginBottom:10}}>
                                        <a target={'_blank'} href={window.innerWidth < 768? 'https://wa.me/' + Env.number : 'https://web.whatsapp.com/send?phone=' + Env.number}>
                                             <img style={{width: 16, height:16}}  src={Images.whats}/> Fale conosco pelo WhatsApp
                                        </a>
                                    </div>
                                    <div>
                                        <a href=""><Link to={'/perguntas-frequentes'}> Perguntas frequentes </Link></a>
                                    </div>*/}
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div className={'primary-sub-color-bg '} style={{fontWeight: 'bold', color: 'white'}}>Icones feitos por <a href="https://www.flaticon.com/authors/inipagistudio" title="inipagistudio">inipagistudio</a> em <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
        </Layout.Footer>
    );
};

Footer.propTypes = {};

export default Footer;
